import React from "react";

const InfoBox = () => {
  return (
    <div className="info-box">
      <h3>Vuoi saperne di più?</h3>
      <p>
        I nostri tecnici Vi sapranno consigliare nella scelta dei materiali più
        adatti alle Vostre esigenze e saranno a Vostra disposizione per
        qualsiasi consulenza, sopralluogo e richiesta di preventivo.
      </p>
      <p className="highlight">
        <strong>Naturalmente gratuito!</strong>
      </p>
    </div>
  );
};

export default InfoBox;
